import { render, staticRenderFns } from "./questions_home.vue?vue&type=template&id=2815fd4d&"
import script from "./questions_home.vue?vue&type=script&lang=js&"
export * from "./questions_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports